export class EnumUtilities {
  private static readonly LABEL_OVERRIDES: Map<string, string> = new Map([
    ['whiteglove', 'White Glove'],
    ['pdf', 'PDF'],

    // EmailType -> plain-English display names (used wherever sent-email types render or
    // filter, e.g. the sent-email browser table and its email-type multi-select).
    ['invitemember', 'Invitation to Join'],
    ['resetpassword', 'Password Reset'],
    ['staffsetpassword', 'Staff Account Setup'],
    ['invoiceissued', 'New Invoice'],
    ['invoicedaybeforedue', 'Invoice Due Tomorrow'],
    ['invoiceduedate', 'Invoice Due Today'],
    ['invoicelate', 'Invoice Past Due'],
    ['invoicemarkedpaid', 'Invoice Marked Paid'],
    ['invoiceunmarkedpaid', 'Invoice No Longer Marked Paid'],
    ['invoicemarkedvoided', 'Invoice Voided'],
    ['invoicelatefeeapplied', 'Late Fee Added'],
    ['invoicelatefeeswaived', 'Late Fee Removed'],
    ['paymentsucceeded', 'Payment Received'],
    ['paymentsucceededmultiple', 'Payment Received (Multiple Invoices)'],
    ['paymentfailed', 'Payment Failed'],
    ['paymentfailedmultiple', 'Payment Failed (Multiple Invoices)'],
    ['paymentpending', 'Payment Processing'],
    ['paymentpendingmultiple', 'Payment Processing (Multiple Invoices)'],
    ['paymentfailedfororg', 'Payment Failed (Org Notice)'],
    ['paymentfailedmultiplefororg', 'Payment Failed (Org Notice, Multiple Invoices)'],
    ['paymentcanceled', 'Payment Canceled'],
    ['paymentcanceledmultiple', 'Payment Canceled (Multiple Invoices)'],
    ['refundsucceededpayer', 'Refund Issued'],
    ['refundsucceededadmin', 'Refund Issued (Org Notice)'],
    ['refundfailedadmin', 'Refund Failed (Org Notice)'],
    ['basicemailblast', 'Email Blast'],
    ['supportticket', 'Support Request'],

    // AddressDeliverability -> the verdict as shown against an entered address.
    ['deliverablewithissues', 'Deliverable with Issues'],

    // Property, User and Organization "Inactive" status reads as "Deactivated" to the user — the
    // state the row was put into by a Deactivate action (DEV-1909). The enum stays Inactive because
    // that's what the API returns.
    ['inactive', 'Deactivated'],
  ]);

  public static convertToLabel(pascalCaseString?: string): string {
    if (!pascalCaseString) return '';

    const override = EnumUtilities.LABEL_OVERRIDES.get(pascalCaseString.toLowerCase());
    if (override) return override;

    // The regex /([A-Z])/g matches all capital letters
    // and replaces them with a space followed by the capital letter
    // then .trim() removes any leading space.
    return pascalCaseString
      .replace(/([A-Z])/g, ' $1')
      .trim();
  }
}
